/**
 * Stable CSS class names for E2E — Customer refund list V2.
 */
export const CRFV2 = {
    page: 'customer-refund-list-v2-page',
    filtersRow: 'customer-refund-list-v2-page__filters-row',
    inputTextfieldOrderNo: 'customer-refund-list-v2-input--textfield-order-no',
    fieldRefundStatus: 'customer-refund-list-v2-field--refund-status',
    inputSelectRefundStatus: 'customer-refund-list-v2-input--select-refund-status',
    inputButtonSearch: 'customer-refund-list-v2-input--button-search',
    datagrid: 'customer-refund-list-v2-page__datagrid',
    inputButtonRefundId: 'customer-refund-list-v2-input--button-refund-id',
} as const;

export const crfv2Cls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
